import { AnalyticsFilterState } from "@/core/entities/analytics/AnalyticsFilterState";
import { IAnalyticsFilterStateRepository } from "@/core/repositories/analyticsFilterState";

export class GetAnalyticsFilterStateUseCase {
  constructor(private readonly repository: IAnalyticsFilterStateRepository) {}

  async execute(): Promise<AnalyticsFilterState | null> {
    return this.repository.getAnalyticsFilterState();
  }
}
